import { Control, Controller } from 'react-hook-form';

import SelectMultiInput from '@/components/inputs/SelectMultiInput';
import { SelectInputOption } from '@/components/inputs/SelectInput';

export interface FormSelectMultiInputProps {
  control: Control<any>;
  name: string;
  placeholder: string;
  options: SelectInputOption[];
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
}

const FormSelectMultiInput = ({
  name,
  placeholder,
  control,
  options,
  required = false,
  disabled = false,
  autoFocus = false,
}: FormSelectMultiInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <SelectMultiInput
          {...field}
          name={name}
          placeholder={placeholder}
          options={options || []}
          errorInfo={error?.message}
          error={!!error}
          autoFocus={autoFocus}
          required={required}
          disabled={disabled}
        />
      )}
    />
  );
};

export default FormSelectMultiInput;

